import RouteTemplate from 'ember-route-template';
import or from 'truth-helpers/helpers/or';

export default RouteTemplate(
  <template>
    <section class="pd-best-for">
      <div class="pd-best-for__hero">
        <h1 class="pd-best-for__title">Best Proxies, <span>by use case</span></h1>
        <p class="pd-best-for__subtitle">
          Hand-picked provider rankings for every workload — from web scraping to
          sneaker copping. Backed by real benchmarks and community reviews.
        </p>
      </div>
    
      <div class="pd-best-for__grid">
        {{#each (or @model.useCases @controller.model.useCases) as |uc|}}
          <a class="pd-best-for__use-case" href={{uc.url}}>
            <span class="pd-best-for__use-case-emoji">{{uc.emoji}}</span>
            <span class="pd-best-for__use-case-label">{{uc.label}}</span>
            <span class="pd-best-for__use-case-count">View ranking →</span>
          </a>
        {{/each}}
      </div>
    </section>

  </template>
);
